import { render, staticRenderFns } from "./PendingLetters.vue?vue&type=template&id=a6f86326&"
import script from "./PendingLetters.vue?vue&type=script&lang=js&"
export * from "./PendingLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports